import { useThema } from "@/stores/Thema"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { FormEvent } from "react"
import { Button } from "@/components/Button"
import { Icon } from "@/components/Icon"
import { IconEdit } from "@tabler/icons-react"
import { Dialog, DialogTrigger, Heading } from "react-aria-components"
import { Modal } from "@/components/Modal/Modal"
import { Form } from "@/components/Form/Form"
import { TextField } from "@/components/TextField"
import { chain } from "react-aria"


interface EditThemeButtonProps {
    id: string
    versionId?: string
    defaultValue: string
}

export const EditThemeButton = ({id, versionId, defaultValue}: EditThemeButtonProps) => {
    const thema = useThema()
    const queryClient = useQueryClient()
    const updateMutation = useMutation({
        mutationFn: thema.updateTheme,
        onSuccess: () => queryClient.invalidateQueries({queryKey: ["history"]})
    })

    const edit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const evt = e.nativeEvent as SubmitEvent
        const data = Object.fromEntries(new FormData(e.currentTarget)) as any

        evt.submitter?.setAttribute("disabled", "true")
        updateMutation.mutate({id, versionId, name: data.name})
    }

    return (
        <DialogTrigger>
            <Button variant="icon" size="sm" className="text-slate-400">
                <Icon icon={IconEdit}/>
            </Button>
            <Modal isDismissable className="w-[650px] max-h-[400px]">
                <Dialog className="outline-none max-h-[inherit] p-8 dark">
                    {({close}) => <>
                        <Heading className="text-xl mb-2">Create Theme</Heading>
                        <Form onSubmit={chain(edit, close)}>
                            <TextField autoFocus label="Name" name="name" defaultValue={defaultValue} />
                            <div className="flex gap-2 justify-end">
                                <Button onPress={close} treatment="link">CANCEL</Button>
                                <Button type="submit" className="flex">SAVE</Button>
                            </div>
                        </Form>
                    </>}
                </Dialog>
            </Modal>
        </DialogTrigger>
    )
}